/**
 * Transforms an value to a number.
 *
 * @param input - The value to transform.
 *
 * @returns The transformed value.
 */
export var toNumber = function toNumber(input) {
  return input;
};